import { UserProfileForm, UserRole } from '@grcs/types/UserRole';
import { createDatabaseService } from '../database/DatabaseService';
import { generateStudentUsername, normalizeStudentInput } from './studentInput';

/** Failed lookups and ambiguous identities must never be interpreted as new students. */
export const getStudent = async (student: UserProfileForm, supabase: any) => {
  const input = normalizeStudentInput(student);
  const username = generateStudentUsername(input.first_name, input.email);
  const db = createDatabaseService(supabase);
  // The default repository query requires deleted=false; archived profiles do not compete for this identity.
  const result = await db.user.getDataById('user', 'username', username);
  if (result.error || !result.data)
    throw new Error(
      'Could not look up the student account. Try again before creating it.',
    );
  if (result.data.length > 1)
    throw new Error(
      'Multiple active profiles use this username. Repair the duplicate profiles first.',
    );
  const user = result.data[0] || null;
  if (
    user &&
    (user.role !== UserRole.STUDENT || user.auth_uid || user.deleted !== false)
  ) {
    throw new Error(
      'This username belongs to a staff, linked, or inactive account. Review the existing profile.',
    );
  }
  // Shared family email addresses are supported; email alone is not a student identity.
  return { username, user };
};
